// import { BrowserModule } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
// services
import { ErrorHandler } from '../../services/error-handler.service';

interface NotificationData {
  id: Number;
  messageType: string;
  topPos: Number;
  textAlign: string;
  isSticky: Boolean;
  icon: string;
  title: string;
  text: string;
}

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  private _timer;

  public notificationsData: NotificationData = {
    id: null,
    messageType: '',
    topPos: 0,
    textAlign: 'left',
    isSticky: false,
    icon: '',
    title: '',
    text: ''
  };
  public notificationsArray: Array<any> = [];

  constructor(
    private _errorService: ErrorHandler
  ) {}

  ngOnInit() {
    this._errorService.notificationItem$
      .subscribe(err => {
        this.create(err);
      });
  }

  create(data: any) {

    let ind = 1;

    if (this.notificationsArray.length > 0) {
      this.notificationsArray.splice(0, 1);
    }

    this.notificationsData = {
      id: ind,
      messageType: data.type,
      topPos: 0,
      textAlign: 'left',
      isSticky: data.sticky,
      icon: data.icon,
      title: data.title,
      text: data.text
    };
    this.notificationsArray.push(this.notificationsData);

    if (!data.sticky) {
      this.autoCloseNotification(this.notificationsData.id);
    }

    ind ++;
  }

  closeNotification(id) {
    for (const item of this.notificationsArray) {
      const i = Object.keys(this.notificationsArray).indexOf(item);
      if (item.id === id) {
        this.notificationsArray.splice(i, 1);
      }
    }
  }

  autoCloseNotification(id) {

    setTimeout(() => {
      for (const item of this.notificationsArray) {
        const i = Object.keys(this.notificationsArray).indexOf(item);
        if (item.id === id) {
          this.notificationsArray.splice(i, 1);
        }
      }
    }, 3500);

  }

}
